import type { DriveStep } from 'driver.js';

const at = (id: string) => `[data-tour="${id}"]`;

/**
 * "Tour this page" for Team (/team). Anchors live in TeamPage.tsx (team-toggle, team-invite,
 * team-roles, team-members — Builder Users view) and AgentsPage.tsx (team-agent-* — the Website
 * Agents view, ?view=agents). Steps for the view that isn't showing are skipped automatically.
 */
export function getTeamTourSteps(): DriveStep[] {
  return [
    {
      popover: {
        title: 'Your team',
        description:
          'This page has two parts: the people who can log in to your account, and the agent ' +
          'profiles that visitors see on your website.',
      },
    },
    {
      element: at('team-toggle'),
      popover: {
        title: 'Builder Users or Website Agents',
        description:
          '“Builder Users” are colleagues who can log in and help with your site. “Website Agents” ' +
          'are the agent profiles shown on your live website. Switch between them here.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: at('team-invite'),
      popover: {
        title: 'Invite someone',
        description:
          'Enter their email and pick a role. We email them an invite, and you also get a link ' +
          'you can copy and send yourself. Invites expire after 7 days.',
        side: 'bottom',
        align: 'end',
      },
    },
    {
      element: at('team-roles'),
      popover: {
        title: 'What each role can do',
        description:
          'Owner can do everything. Admin can do everything except billing. Editor can edit the ' +
          'site, brand and content. Viewer can look but not change anything.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: at('team-members'),
      popover: {
        title: 'Manage your team',
        description:
          'Everyone with access is listed here. From each row you can resend an invite, turn ' +
          'someone off or back on, or remove them. Only the owner can change roles.',
        side: 'top',
        align: 'start',
      },
    },
    {
      element: at('team-agent-add'),
      popover: {
        title: 'Add an agent',
        description:
          'Your agents come in from your MLS automatically. Click “Add Manual Agent” to add ' +
          'someone yourself.',
        side: 'bottom',
        align: 'end',
      },
    },
    {
      element: at('team-agent-edit'),
      popover: {
        title: 'Edit an agent profile',
        description:
          'Update an agent’s name, photo, contact details, bio and more, or mark them as featured. ' +
          'Anything you leave blank keeps what your MLS has. Publish your site afterwards so ' +
          'visitors see the changes.',
        side: 'top',
        align: 'center',
      },
    },
  ];
}
